<template>
  <v-container>
    <!-- <v-col cols="12" class="text-center">
        <span style="font-size: 25px"> 🐂 🐄 🐖 🐐 🐑 🐎</span>
      </v-col> -->

    <!-- Título con botón de retroceso -->
    <v-row align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.push('/ru/pecuarios')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="auto" class="text-center">
        <div class="text-h5 font-weight-bold">🐮 Ingreso de Ganado</div>
        <div class="text-subtitle-2 mt-1">
          Para producción de Reses, Puercos, Búfalos, Cabras, Ovejas y otros
        </div>
      </v-col>
    </v-row>

    <!-- Botones de acción -->
    <v-row class="mb-4" dense>
      <v-col v-if="user_can.add" cols="12" sm="12">
        <v-btn block color="primary" router to="/ru/inventario" depressed>
          <span class="mr-2" style="font-size: 20px">🐖</span>
          <v-icon left>mdi-plus</v-icon>
           agregar nuevo animal 
        </v-btn>
      </v-col>
<!-- 
      <v-col v-if="user_can.add" cols="12" sm="6">
        <v-btn block color="primary" router to="/ru/pecuario" depressed>
          <span class="mr-2" style="font-size: 20px">🐄</span>
          2)Grupo para Engorde o Ceba
        </v-btn>
      </v-col> -->
    </v-row>

    <!-- Buscador -->
    <v-row align="center" class="mb-4">
      <v-col cols="9" sm="9">
        <v-text-field
          v-model="identirubro"
          label="Busca código de Ganado"
          outlined
          dense
          hide-details
          @keyup.enter="buscarPorCodigo"
        />
      </v-col>
      <v-col cols="3" sm="3" class="text-sm-left text-center">
        <v-btn
          color="primary"
          @click="buscarPorCodigo"
          height="40"
          width="40"
          min-width="40"
          class="rounded-circle"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- Resultado de búsqueda -->
    <v-row v-if="resultadoBusqueda && resultadoBusqueda.length > 0">
      <v-col cols="12">
        <v-col cols="12">
          <h3>
            Su Código o ID del ganado buscado es:
            <strong>{{ identirubroBuscado }}</strong>
          </h3>
        </v-col>
        <v-list two-line>
          <template v-for="inventario in resultadoBusqueda">
            <form-card
              :key="inventario.id"
              :top-text="`Animal • ${descripcionActividad(inventario.id_actividad_pecuaria)}`"
              :top-right-text="inventario.fecha"
              :middle-text="`Código de ganado • ${inventario.identirubro ? inventario.identirubro: 'No Tiene'}`"
              :bottom-right-text="producerDescription(inventario.productor)"
              :sincronized="inventario.sincronizado"
              :opaque="inventario.hasOutdatedRecords"
              @click="traerRegistroYNavegar(inventario)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>

    <!-- No se encontró resultado -->
    <v-row v-else-if="busquedaRealizada">
      <v-col cols="12">
        <div class="text-body-2 text-center font-italic">
          No se encontró ninguna producción con ese código.
        </div>
      </v-col>
    </v-row>

    <!-- Texto de instrucción -->
    <v-row v-if="!presionobuscar" class="mb-4">
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-medium">
          Mis producciones y Ventas
        </div>
        <div class="text-body-2">
          Presione el rectángulo para agregar Ventas, producción o modificarlas
        </div>
      </v-col>
    </v-row>

    <!-- Si no hay registros -->
    <v-row v-if="Object.keys(inventarios).length === 0">
      <v-col cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ningun ganado registrado.
        </div>
      </v-col>
    </v-row>

    <!-- Listado local -->
    <v-row>
      <v-col cols="12">
        <v-list two-line>
          <template v-for="inventario in inventarios">
            <form-card
              :key="inventario.id"
              :top-text="`Animal • ${descripcionActividad(inventario.id_actividad_pecuaria)}`"
              :top-right-text="inventario.fecha"
              :middle-text="`Código de ganado • ${inventario.identirubro ? inventario.identirubro: 'No Tiene'}`"
              :bottom-right-text="producerDescription(inventario.productor)"
              :sincronized="inventario.sincronizado"
              :opaque="inventario.hasOutdatedRecords"
              @click="traerRegistroYNavegar(inventario)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Inventarios',
  data() {
    return {
      mi_id_productor: '',
      identirubroBuscado: '',
      identirubro: '',
      resultadoBusqueda: [],
      busquedaRealizada: false,
      buscandoRegistro: false,
      presionobuscar: false,
    }
  },
  computed: {
    ...mapState('registros', ['inventarios']),
    ...mapGetters('registros', [
      'getNombreDeFinca',
      'getNombreDeParcela',
      'productor_actual',
    ]),
    ...mapState('listados', [
      'actividad_pecuaria',

    ]),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Inventarios')
    this.mi_id_productor = this.productor_actual
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getInventario', { id: registro.id })
      }
      // Guardar en localStorage el código buscado
     // localStorage.setItem('identirubroBuscado', this.identirubro?.trim() || '')
      this.$router.push(`/ru/inventario/${registro.id}`)
    },
    async buscarPorCodigo() {
      if (!this.identirubro) return
      this.buscandoRegistro = true
      this.resultadoBusqueda = []
      this.busquedaRealizada = false
      this.presionobuscar = true
      try {
        const registro = this.buscarRegistroPorCodigoLocal()
        if (registro) {
          this.resultadoBusqueda = [registro]
          this.busquedaRealizada = true
        } else {
          // Si no está local, buscar en el servidor
          await this.buscarRegistroPorCodigoEnServidor()
          //console.log('Resultado encontrado:', this.resultadoBusqueda)
        }
      } catch (error) {
        this.resultadoBusqueda = null
        this.busquedaRealizada = true
      } finally {
        this.buscandoRegistro = false
      }
    },
    buscarRegistroPorCodigoLocal() {
      const inventarios = this.$store.state.registros.inventarios
      return Object.values(inventarios).find(
        (inventarios) => inventarios.identirubro === this.identirubro.trim()
      )
    }, 

    async buscarRegistroPorCodigoEnServidor() {
  try {
    const response = await this.$store.dispatch(
      'registros/listarInventarios',
      {
        id_productor: this.mi_id_productor,
        identirubro: this.identirubro.trim(),
      }
    )

    if (response && response.status === 'ok' && Array.isArray(response.data)) {
      this.resultadoBusqueda = response.data.filter(
        inv => inv.identirubro?.trim() === this.identirubro.trim()
      )
    } else {
      this.resultadoBusqueda = []
    }
  } catch (error) {
    this.resultadoBusqueda = []
  }
  this.busquedaRealizada = true
},
    obtenerIdentirubroCorrecto(inventario) {
      if (!inventario.producciones) return 'N/A'
      const encontrado = inventario.producciones.find(
        (prod) => prod.identirubro === this.identirubro
      )
      return encontrado ? encontrado.identirubro : 'N/A'
    },
    descripcionActividad(id) {
      const act = this.actividad_pecuaria.find((a) => a.id === id)
      return act ? act.descripcion : 'Desconocido'
    },
  },
}
</script>
<style>
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>